import React from "react";
import {
  Box,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { motion } from "framer-motion";

const orange = "#ff6600";
const dark = "#000000";
const grayText = "#444444";
const grayTitle = "#333333";
const phone = "593984813777";
const link = `https://wa.me/${phone}`;

const items = [
  {
    title: "Diagnóstico inicial gratuito",
    desc: "Analizamos tu volumen de impresión, equipos actuales y necesidades reales.",
  },
  {
    title: "Equipos de última tecnología",
    desc: "Instalamos impresoras y multifuncionales modernas, eficientes y adaptadas a tu operación.",
  },
  {
    title: "Suministro continuo de insumos",
    desc: "Tóner, tintas y repuestos incluidos sin que tengas que preocuparte por reposiciones.",
  },
  {
    title: "Mantenimiento preventivo y correctivo",
    desc: "Nuestro equipo técnico se encarga de todo para evitar interrupciones.",
  },
  {
    title: "Soporte técnico prioritario",
    desc: "Atención rápida y especializada cuando lo necesites.",
  },
  {
    title: "Control y monitoreo de impresión",
    desc: "Optimiza el uso de recursos con reportes y control de consumo.",
  },
];

const benefits = [
  "Reducción de hasta un 40% en costos de impresión",
  "Eliminación de gastos imprevistos en equipos y reparaciones",
  "Mayor productividad del personal",
  "Equipos siempre operativos",
  "Control total del gasto en impresión",
  "Solución escalable según el crecimiento de tu empresa",
];

const idealFor = [
  "Oficinas administrativas",
  "Empresas comerciales",
  "Instituciones educativas",
  "Estudios contables y jurídicos",
  "Centros médicos",
  "Negocios en expansión",
];

const PrintUX = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleRedirect = () => {
    window.open(link, "_blank");
  };

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#fff",
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 6 },
        overflow: "hidden",
      }}
    >
      <Box sx={{ textAlign: "center", mb: 6, position: "relative", zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, amount: 0.4 }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" },
              fontWeight: "bold",
              mb: 2,
              color: grayTitle,
            }}
          >
            Outsourcing de Impresión Empresarial
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
              color: grayText,
              maxWidth: "950px",
              textAlign: "justify",
              mx: "auto",
              mb: 4,
              lineHeight: 1.7,
            }}
          >
            En <strong style={{ color: orange }}>CMSOLTEC</strong> optimizamos la gestión de impresión de tu empresa para que te concentres en lo que realmente importa: hacer crecer tu negocio. Nuestro servicio de Outsourcing de Impresión está diseñado para reducir costos, mejorar la productividad y eliminar los dolores de cabeza relacionados con el manejo de equipos, insumos y mantenimiento.
          </Typography>
        </motion.div>
      </Box>

      <Grid
        container
        spacing={{ xs: 4, md: 8 }}
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          item
          xs={12}
          md={5}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true, amount: 0.3 }}
            style={{ width: "100%", maxWidth: isMobile ? 300 : 430 }}
          >
            <Box
              onClick={handleRedirect}
              sx={{
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 10px 24px rgba(0,0,0,0.22)",
                cursor: "pointer",
              }}
            >
              <img
                src={require("../../static/media/service/service5.webp")}
                alt="Outsourcing de Impresión Empresarial"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Box>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={7}>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <Typography
              component="h3"
              sx={{
                fontSize: { xs: "1.15rem", sm: "1.25rem", md: "1.45rem" },
                fontWeight: "bold",
                color: dark,
                mb: 3,
              }}
            >
              ¿Qué incluye nuestro servicio?
            </Typography>

            {items.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.15 + index * 0.12, duration: 0.45 }}
                viewport={{ once: true, amount: 0.3 }}
              >
                <Box
                  onClick={handleRedirect}
                  sx={{
                    mb: 2.5,
                    p: 2,
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                    },
                  }}
                >
                  <Typography
                    component="h4"
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.05rem", md: "1.12rem" },
                      fontWeight: "bold",
                      color: dark,
                      mb: 0.5,
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: "0.92rem", sm: "0.97rem", md: "1rem" },
                      color: grayText,
                      lineHeight: 1.6,
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </motion.div>
            ))}
          </motion.div>
        </Grid>
      </Grid>

      <Box sx={{ mt: { xs: 6, md: 8 }, maxWidth: "1100px", mx: "auto" }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <Box
                onClick={handleRedirect}
                sx={{
                  p: { xs: 3, md: 4 },
                  borderRadius: "18px",
                  backgroundColor: "#fff7f1",
                  cursor: "pointer",
                  height: "100%",
                }}
              >
                <Typography
                  component="h3"
                  sx={{
                    fontSize: { xs: "1.15rem", sm: "1.25rem", md: "1.45rem" },
                    fontWeight: "bold",
                    color: dark,
                    mb: 2.5,
                  }}
                >
                  💰 Beneficios para tu empresa
                </Typography>

                {benefits.map((benefit, index) => (
                  <Typography
                    key={index}
                    sx={{
                      fontSize: { xs: "0.95rem", md: "1rem" },
                      color: grayText,
                      lineHeight: 1.8,
                      mb: 1,
                    }}
                  >
                    🔹 {benefit}
                  </Typography>
                ))}
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <Box
                onClick={handleRedirect}
                sx={{
                  p: { xs: 3, md: 4 },
                  borderRadius: "18px",
                  backgroundColor: "#f9f9f9",
                  cursor: "pointer",
                  height: "100%",
                }}
              >
                <Typography
                  component="h3"
                  sx={{
                    fontSize: { xs: "1.15rem", sm: "1.25rem", md: "1.45rem" },
                    fontWeight: "bold",
                    color: dark,
                    mb: 2.5,
                  }}
                >
                  🏢 Ideal para
                </Typography>

                {idealFor.map((item, index) => (
                  <Typography
                    key={index}
                    sx={{
                      fontSize: { xs: "0.95rem", md: "1rem" },
                      color: grayText,
                      lineHeight: 1.8,
                      mb: 1,
                    }}
                  >
                    • {item}
                  </Typography>
                ))}
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ mt: { xs: 6, md: 8 }, maxWidth: "1100px", mx: "auto" }}>
        <motion.div
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <Box
            onClick={handleRedirect}
            sx={{
              p: { xs: 3, md: 5 },
              borderRadius: "20px",
              background: "linear-gradient(135deg, #fff 0%, #fff6ef 100%)",
              boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
              cursor: "pointer",
            }}
          >
            <Typography
              component="h3"
              sx={{
                fontSize: { xs: "1.2rem", sm: "1.35rem", md: "1.6rem" },
                fontWeight: "bold",
                color: dark,
                mb: 2,
              }}
            >
              ¿Por qué elegir CMSOLTEC?
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
                color: grayText,
                lineHeight: 1.8,
                mb: 2.5,
                textAlign: "justify",
              }}
            >
              En CMSOLTEC combinamos experiencia en tecnología, servicio técnico especializado y atención personalizada para ofrecerte una solución integral, confiable y rentable. Nos convertimos en tu aliado tecnológico, asegurando que tu infraestructura de impresión funcione de manera eficiente, segura y sin interrupciones.
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
                color: grayText,
                lineHeight: 1.8,
                textAlign: "justify",
                mb: 3,
              }}
            >
              Solicita una asesoría sin costo. Déjanos evaluar tu situación actual y proponerte una solución a la medida de tu empresa. Contáctanos hoy mismo y empieza a ahorrar desde el primer mes.
            </Typography>

            <Button
              onClick={handleRedirect}
              variant="contained"
              sx={{
                backgroundColor: orange,
                color: "#fff",
                px: 4,
                py: 1.4,
                borderRadius: "999px",
                fontWeight: "bold",
                textTransform: "none",
                fontSize: { xs: "0.95rem", md: "1rem" },
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#e55b00",
                  boxShadow: "none",
                },
              }}
            >
              Contactar al +593 98 481 3777
            </Button>
          </Box>
        </motion.div>
      </Box>
    </Box>
  );
};

export default PrintUX;